import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './usuarioForm';

import { setModoTela, initForm, salvar, alterarSenha, excluir, getLista, salvarPermissao, getListaLoja } from './usuarioActions';

class Usuario extends Component {

	state = {
		linhaSelecionada: null,
		pesquisar: ''
	}

    componentWillMount() {
        this.props.getLista();
        this.props.getListaLoja();
    }

    render() {
        return (
            <div>
                <Content>
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'cadastroSenha' ? (
						<Form cadastroSenha onSubmit={this.props.alterarSenha} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {
		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({  usuario: true, ponto_atendimento: false, vendedor: false, pedido_solicitacao: true });
								}} />
						</Grid>
					</Row>
				</ContentCardHeader>
				<ContentCardBody>
					<input className='form-control'
						 placeholder='Pesquisar'
						 type='text'
						 value={this.state.pesquisar}
						 onChange={e => {
							 this.setState({ ...this.state, pesquisar: e.target.value });
						 }} />
					<Table responsive>
						<THead>
							<Tr>
								<Th alignCenter colspan={1}>Nome</Th>
								<Th alignCenter colspan={1}>Login</Th>
								<Th alignCenter colspan={1}>Lojas</Th>
								<Th alignCenter>Editar Acessos</Th>
								<Th alignCenter>Editar Cadastros</Th>
								<Th alignCenter>Gerenciar Pedidos</Th>
								<Th alignCenter>Solicitar Pedido</Th>
								<Th colspan={1}></Th>
							</Tr>
						</THead>
						<TBody>
							{(this.props.lista).filter(item => {
								if (this.state.pesquisar
									&& !(`${item.nome} ${item.login} ${item.nome_lojas}`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
									return false;
								}
								return true;
							}).map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td alignCenter>{item.nome}</Td>
									<Td alignCenter>{item.login}</Td>
									<Td alignCenter>{item.nome_lojas}</Td>
									<Td alignCenter>
										<input
											type='checkbox'
											checked={item.acesso}
											onChange={data => this.props.salvarPermissao({ ...item, acesso: !item.acesso })} />
									</Td>
									<Td alignCenter>
										<input
											type='checkbox'
											checked={item.cadastro}
											onChange={data => this.props.salvarPermissao({ ...item, cadastro: !item.cadastro })} />
									</Td>
									<Td alignCenter>
										<input
											type='checkbox'
											checked={item.pedido_gerenciamento}
											onChange={data => this.props.salvarPermissao({ ...item, pedido_gerenciamento: !item.pedido_gerenciamento })} />
									</Td>
									<Td alignCenter>
										<input
											type='checkbox'
											checked={item.pedido_solicitacao}
											onChange={data => this.props.salvarPermissao({ ...item, pedido_solicitacao: !item.pedido_solicitacao })} />
									</Td>

									<Td alignRight minWidth={100}>
										<ButtonTable
											type={'warning'}
											icon={'fas fa-pencil-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('cadastro', {
													...item,
													lojas: (item.lojas || []).map(item => item.id)
												});
												this.props.initForm({
													...item,
													lojas: (item.lojas || []).map(item => item.id)
												});
											}} />

										<ButtonTable
											type={'warning'}
											icon={'fas fa-lock'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('cadastroSenha', {
													...item,
													senha: null
												});
												this.props.initForm({
													...item,
													senha: null
												});
											}} />

										<ButtonTable
											type={'danger'}
											icon={'fas fa-trash-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('exclusao', {
													...item,
													senha: null
												});
												this.props.initForm({
													...item,
													senha: null
												});
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.usuario.modoTela,
	lista: state.usuario.lista
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm, salvar, alterarSenha, excluir, getLista, salvarPermissao, getListaLoja }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Usuario);
